import moment from 'moment'
import axios from 'axios'
const CLIENT_BASE_URL = process.env.MIX_CLIENT_BASE_URL
export default {
  state: {
    events: [],
    activeRange: 'ALL',
    customStart: moment().startOf('day'),
    customEnd: moment().add(1, 'month').endOf('day'),
    eventType: 'all',
    location: 'all',
    loadingEvents: false
  },
  mutations: {
    SET_DEFAULTS (state, eventsViewer) {
      if (!eventsViewer) return

      if (eventsViewer.hasOwnProperty('eventType')) {
        state.eventType = eventsViewer.eventType
      }

      if (eventsViewer.hasOwnProperty('eventLocation')) {
        state.location = eventsViewer.eventLocation
      }

      if (eventsViewer.hasOwnProperty('activeRange')) {
        state.activeRange = eventsViewer.activeRange
      }

      if (eventsViewer.hasOwnProperty('startDate')) {
        state.customStart = moment(eventsViewer.startDate, 'YYYY-MM-DD')
      }
      if (eventsViewer.hasOwnProperty('endDate')) {
        state.customStart = moment(eventsViewer.endDate, 'YYYY-MM-DD')
      }
    },
    SET_EVENTS (state, events) {
      state.events = events
    },
    SET_START_DATE (state, date) {
      state.customStart = moment(date).startOf('day')
    },
    SET_END_DATE (state, date) {
      state.customEnd = moment(date).endOf('day')
    },
    SET_EVENT_TYPE (state, eventType) {
      state.eventType = eventType
    },
    SET_LOCATION (state, location) {
      state.location = location
    },
    SET_ACTIVE_RANGE (state, range) {
      state.activeRange = range
    },
    SET_LOADING_EVENTS (state, loading) {
      state.loadingEvents = loading
    }
  },
  getters: {
    startDate (state) {
      if (state.activeRange === 'CUSTOM') {
        return state.customStart
      } else if (state.activeRange === 'NEXT') {
        return moment().add(1, 'month').startOf('day')
      } else {
        return moment().startOf('day')
      }
    },
    endDate (state) {
      switch (state.activeRange) {
        case 'TODAY':
          return moment().endOf('day')
        case 'WEEK':
          return moment().add(6, 'days').endOf('day')
        case 'MONTH':
          return moment().add(1, 'month').endOf('day')
        case 'NEXT':
          return moment().add(2, 'month').endOf('day')
        case 'ALL':
          return moment().add(1, 'year').endOf('day')
        case 'CUSTOM':
          return state.customEnd
      }
    },
    eventsForLocation (state) {
      if (state.location === 'all') {
        return state.events
      }

      return state.events
        .filter(it => it.location.locationId === state.location)
    },
    availableLocations (state) {
      const available = []
      for (const { location } of state.events) {
        if (location.locationId !== '' && !available.find(it => it.locationId === location.locationId)) {
          available.push(location)
        }
      }
      return available
    }
  },
  actions: {
    async retrieveEvents ({ commit, getters, state }) {
      commit('SET_LOADING_EVENTS', true)

      const response = await axios.get('api/events.json', {
        params: {
          searchStartDate: getters.startDate.format('YYYY-MM-DD'),
          searchEndDate: getters.endDate.format('YYYY-MM-DD'),
          ...(state.eventType === 'all' ? {} : { type: state.eventType })
        }
      })
      commit('SET_EVENTS', response.data.data)

      commit('SET_LOADING_EVENTS', false)
    }
  }
}
